import {Injectable} from '@angular/core';
import {IsAuthorizedService} from './is-authorized.service';
import {LocaleService} from './locale.service';
import {Priveleges} from '../../../../projects/api/src/authentication/priveleges.model';
import {CRUDString} from '../../../../projects/api/src/authentication/CRUDString.type';
import {LoginInfo} from '../../../../projects/api/src/authentication/login-info.model';
import {UserPrivelegesObject} from './models/user-priveleges-object';
import {ThemeService} from './theme.service';
import {skip} from 'rxjs/operators';
import {DefaultDashboardService} from './default-dashboard.service';
import {DefaultStateService} from './default-state.service';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import {environment} from '../../../environments/environment';
import {LocalStorageService} from '../../../../projects/api/src/locale-storage/locale-storage.service';

@Injectable()
export class UserService {

  public rawData: any;
  constructor(private isAuthorizedService: IsAuthorizedService,
              private localeService: LocaleService,
              private localStorageApi: LocalStorageService,
              private themeService: ThemeService,
              private defaultDashboardService: DefaultDashboardService,
              private defaultStateService: DefaultStateService) {
    localeService.locale$.pipe(skip(1)).subscribe(locale => {
      if (locale) {
        this.localStorageApi.save(true, 'ilocale_', JSON.stringify(locale.serverShort));
        this.updadeStorage({ilocale: locale.serverShort});
      }
    });
    // themeService.theme.pipe(skip(1)).subscribe(theme => {
      // if (theme) {
      //   this.updadeStorage({theme: theme.id});
      // }
    // });
    defaultDashboardService.id.pipe(skip(1)).subscribe(id => {
      if (id > 0) {
        this.updadeStorage({defaultScreen: id});
      }
    });
/*    defaultStateService.state.pipe(skip(1)).subscribe(state => {
      switch (state) {
        case UserDefaultState.charts:
          this.updadeStorage({defaultScreen: -2});
          break;
        case UserDefaultState.map:
          this.updadeStorage({defaultScreen: -1});
          break;
        case UserDefaultState.home:
          this.updadeStorage({defaultScreen: -0});
          break;
      }
    });*/
  }


  private _privilegesObject: UserPrivelegesObject;


  get privilegesObject(): UserPrivelegesObject {
    return this._privilegesObject;
  }

  set privilegesObject(value: UserPrivelegesObject) {
    this._privilegesObject = value;
  }

  checkReadAccess(resource) {
      return this.hasPrivilege(resource, 'read');
  }

  checkAccess(option) {
    if (option === undefined) {
      return true;
    }
    const [resource, privilege] = option.split(':');
    return this.hasPrivilege(resource, privilege);
  }

  private hasPrivilege(resource: string, privilege: CRUDString) {
    return this.privilegesObject?.[resource] && this.privilegesObject[resource].includes(privilege);
  }

  initialize(userData: LoginInfo) {
    const ilocale = this.localStorageApi.load(true, 'ilocale_');
    if (ilocale) {
      this.localeService.setLocale(ilocale.replace(/"/g, ''));
    } else {
      this.localeService.setLocale(userData.ilocale);
    }
  //    console.log('userData.theme:', userData.theme);
    const themeId = this.localStorageApi.load(true, 'theme');
    this.themeService.theme.next(this.themeService.themes.find(_theme => _theme.id === themeId) || this.themeService.theme.value);
    this.localStorageApi.save(false, 'user', JSON.stringify(userData));
  //  this.localStorageApi.save(true, 'theme', userData.theme + '');
    this.rawData = userData;
    this.isAuthorizedService.isAuthorized.next(true);
    this._privilegesObject = this.collectUserPrivileges(userData.privileges);
    switch (userData.defaultScreen) {
      default:
        this.defaultDashboardService.id.next(userData.defaultScreen);
    }
  }

  logout() {
    this.localStorageApi.remove(false, 'user');
    this.isAuthorizedService.isAuthorized.next(false);
    this.rawData = {};
    this._privilegesObject = {};
    this.defaultDashboardService.id.next(null);
    if (Cookie.get(environment.issCookie)) {
      Cookie.delete(environment.issCookie);
    }

  }

  public updadeStorage(data: LoginInfo) {
    const tmp = this.localStorageApi.load(false, 'user');
    this.localStorageApi.save(false, 'user', JSON.stringify(Object.assign({}, tmp, data)));
  }

  private collectUserPrivileges(privileges: Priveleges[]) {
    const privilegesObject: UserPrivelegesObject = {};
    if (privileges) {
      privileges.forEach((privilege) => {
        const privilegeName = privilege.id.split(':')[0].toLowerCase();
        const privilegeFunction = (<CRUDString>privilege.id.split(':')[1]);

        if (!privilegesObject[privilegeName]) {
          privilegesObject[privilegeName] = [privilegeFunction];
        } else if (privilegesObject[privilegeName].indexOf(privilegeFunction) < 0) {
          privilegesObject[privilegeName].push(privilegeFunction);
        }
      });
    }
    return privilegesObject;
  }
}
